import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityIndicador} from './entity-indicador.model';
import * as Actions from './entity-indicador.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityIndicadoresFeatureKey = 'entityIndicadores';

export interface State extends EntityState<EntityIndicador> {
}

export const adapter: EntityAdapter<EntityIndicador> = createEntityAdapter<EntityIndicador>();

export const initialState: State = adapter.getInitialState(initial);

const entityActions: ActionsExample<EntityIndicador> = {
  add: Actions.addEntityIndicador,
  adds: Actions.addEntityIndicadores,
  clear: Actions.clearEntityIndicadores,
  remove: Actions.deleteEntityIndicador,
  removes: Actions.deleteEntityIndicadores,
  load: Actions.loadEntityIndicadores,
  update: Actions.updateEntityIndicador,
  updates: Actions.updateEntityIndicadores,
  upsert: Actions.upsertEntityIndicador,
  upserts: Actions.upsertEntityIndicadores,
};

const entityIndicadorReducer = entityReducer(initialState, entityActions, adapter);

export function reducer(state: State | undefined, action: Action): State {
  return entityIndicadorReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


